export class Facility {
	static facilities(name) {
		return {
			'cafetariaRoomPhotos': 'Cafetaria Room Photos',
			'femaleWashroomRoomPhotos': 'Female Wash Room Photos',
			'laboratoryRoomPhotos': 'Laboratory Room Photos',
			'maleWashroomRoomPhotos': 'Male Wash Room Photos',
			'trainingRoomPhotos': 'Training Room Photos',
			'unisexWashroomRoomPhotos': 'Unisex Washroom Room Photos',
			'washroomRoomPhotos': 'Washroom Room Photos',
			'threePhasePowerConnection': 'Three Phase Power Connection',
			'staffRoom': 'Staff Room Photos',
			'residentialTraining': 'Residential Training Photos',
			'powerBackupFacility': 'Power Backup Facility Photos',
			'physicalDisabledFriendly': 'Physical Disabled Friendly Photos',
			'parkingFacility': 'Parking Facility Photos',
			'vVideoConFacility': 'VVideoCon Facility Photos',
			'avVideoConFacilityDocument': 'Av Video Con Facility Photos',
			'biometricTrainingAttendance': 'Biometric Training Attendance Photos',
			'biometricTrainingAttendanceDocument': 'Biometric Training Attendance Photos',
			'cafetariaDiningRoom': 'Cafetaria Dining Room Photos',
			'cafetariaDiningRoomDocument': 'Cafetaria Dining Room Photos',
			'cctvFacility': 'Cctv Facility Photos',
			'cctvFacilityDocument': 'Cctv Facility Photos',
			'counsellingRoomPlacementCell': 'Counselling Room Placement Cell Photos',
			'counsellingRoomPlacementCellDocument': 'Counselling Room Placement Cell Photos',
			'fireSafetyEquipment': 'Fire Safety Equipment Photos',
			'fireSafetyEquipmentDocument': 'Fire Safety Equipment Photos',
			'firstAidKitAvailability': 'First Aid Kit Availability Photos',
			'firstAidKitAvailabilityDocument': 'First Aid Kit Availability Photos',
			'internetConnectivity': 'Internet Connectivity Photos',
			'internetConnectivityDocument': 'Internet Connectivity Photos',
			'library': 'Library Photos',
			'libraryDocument': 'Library Photos',
			'nsdcBrandingCentralFacade': 'NSDC Branding Central Facade Photos',
			'nsdcBrandingCentralFacadeDocument': 'NSDC Branding Central Facade Photos',
			'nsdcBrandingCentreReception': 'NSDC Branding Centre Reception Photos',
			'nsdcBrandingCentreReceptionDocument': 'NSDC Branding Centre Reception Photos',
			'nsdcBrandingClassroom': 'NSDC Branding Classroom Photos',
			'nsdcBrandingClassroomDocument': 'NSDC Branding Classroom Photos',
			'nsdcBrandingOthers': 'NSDC Branding Others Photos',
			'nsdcBrandingOthersDocument': 'NSDC Branding Others Photos',
			'parkingFacilityDocument': 'Parking Facility Photos',
			'physicalDisabledFriendlyDocument': 'Physical Disabled Friendly Photos',
			'powerBackupFacilityDocument': 'Power Backup Facility Photos',
			'residentialTrainingDocument': 'Residential Training Photos',
			'staffRoomDocument': 'Staff Room Photos',
			'threePhasePowerConnectionDocument': 'Three Phase Power Connection Photos'
		}[name]
	}

	static withOutNamePhoto(name) {
			return {
				'cafetariaRoomPhotos': 'Cafetaria Room',
				'femaleWashroomRoomPhotos': 'Female Wash Room',
				'laboratoryRoomPhotos': 'Laboratory Room',
				'maleWashroomRoomPhotos': 'Male WashRoom',
				'trainingRoomPhotos': 'Training Room',
				'unisexWashroomRoomPhotos': 'Unisex Washroom Room',
				'washroomRoomPhotos': 'Washroom Room',
				'threePhasePowerConnection': 'Three Phase Power Connection',
				'staffRoom': 'Staff Room',
				'residentialTraining': 'Residential Training',
				'powerBackupFacility': 'Power Backup Facility',
				'physicalDisabledFriendly': 'Physical Disabled Friendly',
				'parkingFacility': 'Parking Facility',
				'vVideoConFacility': 'VVideoCon Facility',
				'avVideoConFacilityDocument': 'Av Video Con Facility',
				'biometricTrainingAttendance': 'Biometric Training Attendance',
				'biometricTrainingAttendanceDocument': 'Biometric Training Attendance',
				'cafetariaDiningRoom': 'Cafetaria Dining Room',
				'cafetariaDiningRoomDocument': 'Cafetaria Dining Room',
				'cctvFacility': 'Cctv Facility',
				'cctvFacilityDocument': 'Cctv Facility',
				'counsellingRoomPlacementCell': 'Counselling Room Placement Cell',
				'counsellingRoomPlacementCellDocument': 'Counselling Room Placement Cell',
				'fireSafetyEquipment': 'Fire Safety Equipment',
				'fireSafetyEquipmentDocument': 'Fire Safety Equipment',
				'firstAidKitAvailability': 'First Aid Kit Availability',
				'firstAidKitAvailabilityDocument': 'First Aid Kit Availability',
				'internetConnectivity': 'Internet Connectivity',
				'internetConnectivityDocument': 'Internet Connectivity',
				'library': 'Library',
				'libraryDocument': 'Library',
				'nsdcBrandingCentralFacade': 'NSDC Branding Central Facade',
				'nsdcBrandingCentralFacadeDocument': 'NSDC Branding Central Facade',
				'nsdcBrandingCentreReception': 'NSDC Branding Centre Reception',
				'nsdcBrandingCentreReceptionDocument': 'NSDC Branding Centre Reception',
				'nsdcBrandingClassroom': 'NSDC Branding Classroom',
				'nsdcBrandingClassroomDocument': 'NSDC Branding Classroom',
				'nsdcBrandingOthers': 'NSDC Branding Others',
				'nsdcBrandingOthersDocument': 'NSDC Branding Others',
				'parkingFacilityDocument': 'Parking Facility',
				'physicalDisabledFriendlyDocument': 'Physical Disabled Friendly',
				'powerBackupFacilityDocument': 'Power Backup Facility',
				'residentialTrainingDocument': 'Residential Training',
				'staffRoomDocument': 'Staff Room',
				'threePhasePowerConnectionDocument': 'Three Phase Power Connection'
			}[name]
	}
}
